package com.exura.features.legacyplans.domain.model

import com.exura.features.plandefinition.domain.model.series.PartOfDay
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class TimelyTask(
    override val id: String,
    override var planId: String,
    override val instructionId: String,
    override val seriesId: String,
    override val startFrom: LocalDateTime?,
    override val endAt: LocalDateTime?,
    override val notificationId: Int,
    val title: String,
    val description: String,
    val tutorial: String,
    val videoUrl: String,
    val partOfDay: PartOfDay?,
    val doneAt: LocalDateTime? = null,
) : TimelyElement
